import type { AttentionCardMessageCaseModel } from '@components/attention_card/_attention_card.controller';
import { withTranslation } from '@modules/i18n_and_l10n/with_translation';
import { AttentionCardCaseCardMessage } from './_attention_card_case_card_message.component';

interface Props {
	message: AttentionCardMessageCaseModel;
}

export function AttentionCardTypeNewMessage({ message }: Props): JSX.Element {
	return (
		<AttentionCardCaseCardMessage
			description={withTranslation('PW.Component.AttentionCard.Message.Description')}
			message={message}
			analyticAction='Clicked Unread message-card'
		/>
	);
}
